import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { RecordTypeHttpClient } from 'src/app/shared/flight-log-api/record-types/record-types-client.service';
import { ReportTypeHttpClient } from 'src/app/shared/flight-log-api/report-types/report-types-client.service';
import { TestTypeHttpClient } from 'src/app/shared/flight-log-api/test-types/test-types-client.service';
import { DrugAlcoholRecordEntity } from 'src/store/drug-alcohol-record/drug-alcohol-record.model';
import { RecordTypeViewModel } from './record-type-view-model';
import { ReportTypeViewModel } from './report-type-view-model';
import { TestTypeViewModel } from './test-type-view-model';

export class DrugAlcoholRecordViewModel implements DrugAlcoholRecordEntity {
  public id: string;
  public pilotId: string;
  public prdSourceSystemId: string;
  public occurrenceDate: Date;
  public recordTypeId: string;
  public reportTypeId: string;
  public testTypeId: string;
  public suppressed: boolean;
  public processingState: string;
  public processingError: string;
  public lastProcessedDate: Date;
  public recordType$: Observable<RecordTypeViewModel | undefined>;
  public reportType$: Observable<ReportTypeViewModel | undefined>;
  public testType$: Observable<TestTypeViewModel | undefined>;

  constructor(
    drugAlcoholRecord: DrugAlcoholRecordEntity,
    _recordType: RecordTypeHttpClient,
    _reportType: ReportTypeHttpClient,
    _testType: TestTypeHttpClient,
  ) {
    Object.assign(this, drugAlcoholRecord);
    if (this.recordTypeId) {
      this.recordType$ = _recordType
        .getAll({ id: this.recordTypeId })
        .pipe(map((r) => r.results[0]));
    } else {
      this.recordType$ = of(undefined);
    }
    if (this.reportTypeId && this.recordTypeId) {
      this.reportType$ = _reportType
        .getByRecordTypeId(this.recordTypeId)
        .pipe(map((r) => r.results.filter((reportType) => reportType.id === this.reportTypeId)[0]));
    } else {
      this.reportType$ = of(undefined);
    }
    if (this.testTypeId && this.reportTypeId) {
      this.testType$ = _testType
        .getByReportTypeId(this.reportTypeId)
        .pipe(map((r) => r.results.filter((testType) => testType.id === this.testTypeId)[0]));
    } else {
      this.testType$ = of(undefined);
    }
  }
}
